import React from 'react';
import {
  Box,
  Divider,
  makeStyles,
  createStyles,
  Theme,
} from '@material-ui/core';
import SwapVertIcon from '@material-ui/icons/SwapVert';
import { PromptItemHeader } from './PromptItemHeader';
import { PromptSuggestion } from './PromptSuggestion';
import { PromptData } from './types';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      backgroundColor: theme.palette.background.default,
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: '8px',
      padding: '16px',
    },
    suggestions: {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
    },
    divider: {
      display: 'flex',
      justifyContent: 'center',
      padding: '8px 0',
    },
    dividerIcon: {
      color: theme.palette.text.secondary,
    },
  }),
);

export interface PromptItemProps extends PromptData {
  onCopy?: (id: string) => void;
  onAddPrompt?: (id: string, promptText: string) => void;
  className?: string;
}

export const PromptItem: React.FC<PromptItemProps> = ({
  id,
  title,
  similarCount,
  usedByCount,
  users,
  suggestedPrompt,
  relatedPrompt,
  showRelatedFromLibrary = false,
  onCopy,
  onAddPrompt,
  className = '',
}) => {
  const classes = useStyles();

  const handleCopy = () => {
    if (onCopy) {
      onCopy(id);
    }
  };

  const handleAddPrompt = (promptText: string) => {
    if (onAddPrompt) {
      onAddPrompt(id, promptText);
    }
  };

  return (
    <Box className={`${classes.container} ${className}`}>
      <PromptItemHeader
        title={title}
        similarCount={similarCount}
        usedByCount={usedByCount}
        users={users}
        onCopy={handleCopy}
      />

      <Box className={classes.suggestions}>
        <PromptSuggestion
          label="Suggested Optimized Prompt:"
          text={suggestedPrompt}
          variant="optimized"
          onAddPrompt={() => handleAddPrompt(suggestedPrompt)}
        />

        {showRelatedFromLibrary && relatedPrompt && (
          <>
            <Box className={classes.divider}>
              <SwapVertIcon className={classes.dividerIcon} />
            </Box>
            <PromptSuggestion
              label="Related Prompts from Our Library:"
              text={relatedPrompt}
              variant="library"
              showButton={false}
            />
          </>
        )}
      </Box>
    </Box>
  );
};
